import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMail, uploadEditorImage } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { getRoleListV1, commonAPI, AddExclUserData, adminUser, editExclUser } from '../../API/FetchCall';
import Autosuggest from 'react-autosuggest';

import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


class exclusiveUserEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      menu_list: [],
      showPassword: false,
      showCPassword: false,
      errors: [],
      user_name: '',
      email_id: '',
      role: '',
      password: '',
      confirm_password: '',
      login_id: this.props.match.params.id ? this.props.match.params.id : ''
    };
  }
  componentDidMount() {

    this.EditSubuser();

  }
  handleShowPassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }
  handleShowCPassword() {
    this.setState((prevState) => ({
      showCPassword: !prevState.showCPassword,
    }));
  }


  EditSubuser() {

    let ins = JSON.stringify({
      login_id: this.state.login_id
    });
    if (this.state.login_id != '') {
      editExclUser(ins).then((res) => {
        if (res.status == 1) {
          console.log('res', res.data)
          this.setState({
            user_name: res.data.user_name,
            email_id: res.data.email_id,
            role: res.data.role,
          });
        }
      });
    }

  }



  UNSAFE_componentWillMount() { }

  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }

  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    this.clearValidationErr(propName);
  };


  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);

    this.setState({ [propName]: value });
    this.clearValidationErr(propName);
  };


  showValidationErr(elm, msg) {
    this.setState((prevState) => ({
      errors: [...prevState.errors, { elm, msg }],
    }));
  }
  clearValidationErr(elm) {
    this.setState((prevState) => {
      let newArr = [];
      for (let err of this.state.errors) {
        if (elm !== err.elm) {
          newArr.push(err);
        }
      }
      return { errors: newArr };
    });
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let toastr = '';
    if (this.state.user_name != '' && this.state.email_id != '' && this.state.password != '' && this.state.confirm_password != ''
      && (this.state.password == this.state.confirm_password)) {

      let insert = JSON.stringify({
        user_name: this.state.user_name,
        email_id: this.state.email_id,
        password: this.state.password,
        optiontoshow:this.state.optiontoshow,
        role: 11,
        login_id: this.state.login_id ? this.state.login_id : '',
      });

      AddExclUserData(insert).then((response) => {
        if (response.status == 1) {
          alert("Added");
          setTimeout(function () {
            window.location.replace('/users/exclusivepartners');
          }, 1000);
        } else {
          alert("Error adding"); 
          setTimeout(function () {
          }, 1000);
        }
      });

    } else {
      if (this.state.user_name === '') {
        this.showValidationErr('user_name', 'Enter name');
      }
      if (this.state.email_id === '') {
        this.showValidationErr('email_id', 'Enter Email Id');
      }

      if (this.state.password === '') {
        this.showValidationErr('password', 'Enter Password');
      }
      if (this.state.confirm_password === '') {
        this.showValidationErr('confirm_password', 'Enter Confirm Password');
      }
      if (this.state.password != this.state.confirm_password) {
        this.showValidationErr('confirm_password', 'Password Miss Match');
      }
    }


  };

  render() {

 let user_nameErr = null, email_idErr = null, roleErr = null, passwordErr = null,
      confirm_passwordErr = null;
    for (let err of this.state.errors) {
      if (err.elm === 'user_name') {
        user_nameErr = err.msg;
      }
      if (err.elm === 'email_id') {
        email_idErr = err.msg;
      }
      if (err.elm === 'role') {
        roleErr = err.msg;
      }
      if (err.elm === 'password') {
        passwordErr = err.msg;
      }
      if (err.elm === 'confirm_password') {
        confirm_passwordErr = err.msg;
      }

    }


        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">User - Edit</h4>
                    
                   <div id="company-info">
                       <form
                        encType="multipart/form-data"
                        method="post"
                        onSubmit={this.handleSubmit}
                        autoComplete="off"
                        className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no"
                      >
                        <div className="box-shadow-custom">
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label>
                                Name.<span className="astrick">*</span>
                              </label>
                              <input

                                type="text"
                                className="form-control"
                                name="user_name"
                                value={this.state.user_name}
                                onChange={this.handleChange}
                              />
                              <small className="alert-msg text-danger">
                                {user_nameErr ? user_nameErr : ''}
                              </small>
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Email Id<span className="astrick">*</span>
                              </label>
                              <input

                                type="email"
                                className="form-control"
                                name="email_id"
                                value={this.state.email_id}
                                onChange={this.handleChange}
                              />
                              <small className="alert-msg text-danger">
                                {email_idErr ? email_idErr : ''}
                              </small>
                            </div>
                            <div className="form-group col-md-4">
                              <label>
                                Role
                                <span className="astrick">*</span>
                              </label>
                              <div className="custom-select-drop dropdown">
                               
                                <input type="hidden" name="role" value="11" />
                                Exclusive Partnership
                                <br />
                            
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label>
                                Password <span className="astrick">*</span>
                              </label>
                              <input
                                type={this.state.showPassword ? 'text' : 'password'}
                                name="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              <span
                                toggle='#password-field'
                                className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                onClick={() => {
                                  this.handleShowPassword();
                                }}
                              ></span>

                            </div>

                            <div className="form-group col-md-4">
                              <label>
                                Confirm Password <span className="astrick">*</span>
                              </label>
                              <input
                              type={this.state.showCPassword ? 'text' : 'password'}
                                name="confirm_password"
                                value={this.state.confirm_password}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              <span
                                toggle='#password-field'
                                className={this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon plogin' : 'fa fa-fw fa-eye field-icon plogin'}
                                onClick={() => {
                                  this.handleShowCPassword();
                                }}
                              ></span>

                            </div>

                            <div className="form-group col-md-4">
                              <label>
                                Type <span className="astrick">*</span>
                              </label>
                              <select name="optiontoshow" class="inputcls"  onChange={this.handleChange}>
                                  <option value="onlypartners">B2B</option>
                                  <option value="onlyparents">B2C</option>
                                  <option value="both">B2B and B2C</option>
                              </select>

                            </div>


                          </div>
                        </div>

                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm">Submit</button>
                        </div>
                      </form>
                    </div>


                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }
}



export default exclusiveUserEdit;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveUserEdit.jsx